import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import * as React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import theme from './theme';
import 'ms-react-progress-bar/dist/ProgressBar.css';
import { Footer } from './components/Footer';

ReactDOM.render(
	<React.StrictMode>
		<ChakraProvider theme={theme}>
			<ColorModeScript initialColorMode={theme.config.initialColorMode} />
			<App />
			<Footer />
		</ChakraProvider>
	</React.StrictMode>,
	document.getElementById('root')
);

serviceWorker.unregister();
reportWebVitals();
